module.exports = __webpack_public_path__ + "img/welfarebanner.92b2ab9e.png";